// extracted by mini-css-extract-plugin
export var dayLabel = "_kt-0";
export var pickerDisabled = "_kt-1";